import * as _ from 'lodash'

export const memberSummary = members => {
    const numMembers = _.size(members)
    const onlyOneMember = numMembers === 1
    const memberName = onlyOneMember ? `${members[0].person.givenName} ${members[0].person.familyName}` : ''
    return { numMembers, onlyOneMember, memberName }
}
